import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Stopka from "../components/stopka";

const Spektakl = ({ title, content, gallery, heroImage }) => {
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        document.body.style.overflow = selectedImage ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [selectedImage]);

    return (
        <div className="bg-[#0d0d0d] min-h-screen text-white">
            <Navbar />
            <main className="pt-32">
                <section className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16 pb-20">
                    <p className="text-red-400 text-xs uppercase tracking-[0.3em] text-center mb-4">
                        Spektakl Teatru Łątek Supraśl
                    </p>
                    <div className="max-w-3xl mx-auto mb-10 overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-black/40">
                        <img
                            src={heroImage}
                            alt={title}
                            className="w-full max-h-[520px] object-cover"
                        />
                    </div>
                    <h1 className="text-4xl md:text-6xl font-semibold text-center tracking-wide mb-8">
                        {title}
                    </h1>
                    <div className="w-16 h-px bg-red-500 mx-auto mb-12" />
                    <p className="max-w-3xl mx-auto text-base md:text-lg leading-relaxed text-gray-300">
                        {content}
                    </p>

                    <section className="mt-20" aria-labelledby="galeria-spektaklu">
                        <h2 id="galeria-spektaklu" className="text-2xl md:text-3xl font-semibold text-center mb-3">
                            Galeria
                        </h2>
                        <div className="w-12 h-px bg-red-500 mx-auto mb-8" />
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {gallery.map((image, index) => (
                                <button
                                    key={image.src}
                                    type="button"
                                    onClick={() => setSelectedImage(image)}
                                    className={`group relative overflow-hidden rounded-xl border border-white/10 bg-[#161616] ${
                                        index === 0 ? "sm:col-span-2 lg:col-span-2" : ""
                                    }`}
                                    aria-label={`Powiększ zdjęcie ${index + 1}`}
                                >
                                    <img
                                        src={image.src}
                                        alt={image.alt}
                                        className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                    <span className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors duration-300" />
                                </button>
                            ))}
                        </div>
                    </section>
                </section>
            </main>
            <Stopka />

            {selectedImage && (
                <div
                    className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/90"
                    onClick={() => setSelectedImage(null)}
                    role="dialog"
                    aria-modal="true"
                    aria-label="Powiększone zdjęcie"
                >
                    <button
                        type="button"
                        onClick={() => setSelectedImage(null)}
                        className="absolute top-6 right-6 text-white/80 hover:text-white text-2xl"
                        aria-label="Zamknij zdjęcie"
                    >
                        ✕
                    </button>
                    <img
                        src={selectedImage.src}
                        alt={selectedImage.alt}
                        className="max-w-full max-h-[90vh] object-contain rounded-lg"
                        onClick={(event) => event.stopPropagation()}
                    />
                </div>
            )}
        </div>
    );
};

export default Spektakl;
